export const WEBHOOK_PRODUCT_INFO = {
    SIG: [
        "V1 is released with API key-based authentication to protect access from public. SIG API module will provide an API key as a part of header for all communication to the company API endpoint. Key should be configured in SIG API endpoint settings page, usually an API key is generated from company API management system to authenticate SIG API module to post event information.",
        "API key will be provided in the header with name x-api-Key. Company API management system can use this header to authenticate SIG API module.",
        "e.g. x-api-key: 9a9a4cc3-01c7-4cb0-b1"
    ],
    SSE: [
        "V1 is released with API key-based authentication to protect access from public. SSE API module will provide an API key as a part of header for all communication to the company API endpoint. Key can be configured in SSE API endpoint settings page, usually an API key is generated from company API management system to authenticate SSE API module to post event information.",
        "API key will be provided in the header with name x-api-Key. Company API management system can use this header to authenticate SSE API module.",
        "e.g. x-api-key: 9a9a4cc3-01c7-4cb0-b1"
    ],
    SSO: [
        "V1 is released with API key-based authentication to protect access from public. ORG API module will provide an API key as a part of header for all communication to the company API endpoint. Key should be configured in ORG API endpoint settings page, usually an API key is generated from company API management system to authenticate ORG API module to post event information.",
        "API key will be provided in the header with name x-api-Key. Company API management system can use this header to authenticate ORG API module.",
        "e.g. x-api-key: 9a9a4cc3-01c7-4cb0-b1."
    ],
    SSR: [
        "V1 is released with API key-based authentication to protect access from public. SSR API module will provide an API key as a part of header for all communication to the company API endpoint. Key should be configured in SSR API endpoint settings page, usually an API key is generated from company API management system to authenticate SSR API module to post event information.",
        "API key will be provided in the header with name x-api-Key. Company API management system can use this header to authenticate SSR API module.",
        "e.g. x-api-key: 9a9a4cc3-01c7-4cb0-b1"
    ],
    ClMgnt: [
        "V1 is released with API key-based authentication to protect access from public. Client Management module will provide an API key as a part of header for all communication to the company API endpoint. Key should be configured in Client Management API endpoint settings page, usually an API key is generated from company API management system to authenticate Client Management API module to post event information.",
        "API key will be provided in the header with name x-api-Key. Company API management system can use this header to authenticate Client Management API module.",
        "e.g. x-api-key: 9a9a4cc3-01c7-4cb0-b1"
    ],
    GTR: [
        "V1 is released with API key-based authentication to protect access from public. GTR API module will provide an API key as a part of header for all communication to the company API endpoint. Key should be configured in GTR API endpoint settings page, usually an API key is generated from company API management system to authenticate GTR API module to post event information.",
        "API key will be provided in the header with name x-api-Key. Company API management system can use this header to authenticate GTR API module.",
        "e.g. x-api-key: 9a9a4cc3-01c7-4cb0-b1"
    ]
}

export const WEBHOOK_DESCRIPTION = {
    documentSigned: "Once the user completes the signing process, SIG API module will deliver the event information to an API endpoint including signed/partially signed documents SAS link. API endpoint configuration can be found in SIG Settings under Developer Section page.",
    downloadDrlDocument: "Once the client uploads the document from document request list, SSE API module will deliver the event information to an API endpoint including uploaded document SAS link. API endpoint configuration can be found in SSE Settings under Developer Section page.",
    clientChange: "Once the user Add/Edit/Deletes any client using Suite or Other Product like Safe send Return/Signature/Organizer etc, Client management module will deliver the event information to an API endpoint with the updated client information. API endpoint configuration can be found in Client Management under Developer Section page."
}

export const WEBHOOK_USE_CASE_HEADERS = [
    "Endpoint communication successful – 2xx – (Success)",
    "Endpoint communication failed – 500 to 505 status codes.",
    "Endpoint communication failed – All other responses – 401 - Unauthorized, 403 – Forbidden etc."
]

export const WEBHOOK_USE_CASE = {
    documentSigned: {
        success: [
            "Once the signing process is completed – SIG API module delivers the event information with API key authentication.",
            "Document information (signed/partially signed documents) includes SAS link with 1 hour expiry time – using this link third party services can download the file(s)."
        ],
        failed_500: [
            "SIG API module will stop if 10 events delivery to API endpoint returns - 500 to 505 status codes and sends email notification to the configured emails in API End point settings.",
            "No further events will be delivered to the API endpoint.",
            "SIG API module will log all the delivery failed events after the service stopped.",
            "User can resume the service at any time (like - once the communication issues fixed) from the API settings page in SIG. The pending events for delivery will process one by one once user resumes the service."
        ],
        failed_other: [
            "SIG API module will retry 3 times, post that the service will stop and sends email notification to the configured emails in API End point settings.",
            "No further events will be delivered to the API endpoint.",
            "SIG API module will log all the failed delivery events after the service is stopped.",
            "User can resume the service at any time (like - once the communication issues fixed) from the API settings page in SIG. The events pending to deliver will process sequentially once user resumes the service."
        ]
    },
    downloadDrlDocument: {
        success: [
            "Once the document is uploaded – SSE API module delivers the event information with API key authentication.",
            "Event information includes SAS link with 1 hour expiry time – using this link third party services can download the requested document from DRL."
        ],
        failed_500: [
            "SSE API module will stop if 10 events delivery to API endpoint returns – 500 to 505 Status codes and sends email notification to the configured emails in API End point settings.",
            "No further events will be delivered to the API endpoint.",
            "SSE API module will log all the delivery failed events after the service stopped.",
            "User can resume the service at any time (like - once the communication issues fixed) from the API settings page in SSE. The pending events for delivery will be processed one by one once the user resumes the service."
        ],
        failed_other: [
            "SSE API module will retry 3 times, post that the service will stop and sends email notification to the configured emails in API End point settings.",
            "No further events will be delivered to the API endpoint.",
            "SSE API module will log all the failed delivery events after the service is stopped.",
            "User can resume the service at any time (like - once the communication issues fixed) from the API settings page in SSE. The events pending to deliver will process sequentially once user resumes the service."
        ]
    }
}

const commonUniqueArgsDescription = (productName: string) =>
    `Value configured in ${productName} API endpoint settings page, will provide the same value as part of the request body.`;

const commonClientIdDescription = (productName: string) => `Name given to a tax document during the upload time in ${productName}.`;

export const WEBHOOK_FIELDS_DESCRIPTION = {
    taxYear: "Tax document Year.",
    documentNameDescription: "Name of the file.",
    documentSasUrlDescription: "SAS Uri with 1 hour expiry time – it is used to download the file.",
    taxPayerNameDescription: "Name of Taxpayer.",
    taxPayerEmailDescription: "Taxpayer’s email id.",
    eroSignerDescription: "Name of ERO Signer.",
    assignedToDescription: "Name of Assigned to User.",
    documentGuidDescription: "Unique Id of upload organizer.",
    eventType0: "It means test connection.",
    eventType1000: "Download Esign Document",
    eventType1001: "Return Status Changed",
    eventType2000: "It means Engagement Letter Signed Event.",
    eventType2001: "It means Organizer Completed Event.",
    eventType2002: "It means Source Document Uploaded Event.",
    eventType2003: "It means Accessed Organizer Notification Event.",
    eventType3000: "Document Signed.",
    eventType3001: "Signature status Changed.",
    eventType4000: "It means Download DRL Document.",
    eventType5001: "Client Data Changed.",
    eventType6000: "It means Download Esign Documents Event.",
    eventType6001: "It means Download Fillable Organizer Event.",
    eventType6002: "It means Download Source Documents Event.",
    uploadedOnDescription: "It is source document uploaded date.",
    batchNameDescription: "Batch name if organizer uploaded as batch.",
    accessedOnDescription: "Date on which taxpayer accessed the organizer.",
    documentId: "Unique integer Id of upload tax document.",
    engagementType: " Tax document type -1040,1065,1120, etc.",
    httpStatus: "Status code of the event. Value will be 200/500",
    message: "Status messages of the event whether it successful or not.",
    status: "The document’s status • READY • ERROR • PROCESSING • REVIEW • APPROVED FOR DELIVERY • PREPARING FOR DELIVERY • DELIVERY FAILED • NONSUPPORTED • RECALLED • REPROCESSING • TAXCADDY DELIVERY FAILED • DOWNLOADING FAILED • PREPARING FOR PDF DOWNLOAD • TO BE REPROCESSED • E - SIGNED • MANUALLY SIGNED • UPLOADED • AWAITING E - SIGN • AWAITING UPLOAD • SIGNED AND E - SIGNED • DELIVERED TO TAXCADDY • ALTERNATE DELIVERY • ALTERNATE AND UPLOADED • DUPLICATE • SIGNATURE STAMPING FAILED • AWAITING DRAFT REVIEW • DRAFT APPROVED • DRAFT NOT APPROVED • FINAL RETURN COPY CREATED • DRAFT APPROVED - READY TO FINALIZE",
    statusDate: "The date time when the status got updated.",
    eroEmail: "Email address of the document ERO.",
    assignedEmail: "Email address of the assigned CPA.",
    formType: "The document’s form type • E1040 • E1065 • E1120 • E1120S • E1041 • E1040NR",
    clientType: "Tax payer,spouse, partner etc.",
    name: "Name of the client.",
    email: "Email address of the client.",
    ssn: "Social Society number of the client.",
    uId: "Unique id of the client.",
    location: "Office location of the client.",
    mfj: "Is client Married Filing Jointly.",
    mobile: "Mobile number of the Client.",
    countryCode: "Country code of the Client.",
    actionType: "Type of Action performed on Client like Adding/Updating/Deleting client.",
    actionDate: "Date on which client action is performed.",
    spouseEmail: "Spouse’s email id.",
    organizerId: "Unique Short Id string for the organizer.",
    taxReturnId: "Unique short Id string for the tax return."
};

export const SSR_DownloadESignedDocumentDescription = {
    documentGuid: "Unique Guid of upload tax document.",
    documentStatus: "Document status – Uploaded, Ready, UserSigned etc.",
    signatureStatus: "Sign status – ESigned, ManuallySigned etc",
    signedOn: "Document Signed Date.",
    taxSoftware: "Tax document generated software – CCH, UltraTax, Go system etc.",
    deliveredOn: "Tax document delivered date",
    documentClientsClientType: "Client type – Tax payer, spouse, partner etc.",
    documentClientsName: "Name of the client.",
    documentClientsEmail: "Email address of the client.",
    documentClientsSsn: "Social Security number of the client.",
    clientId: commonClientIdDescription("SSR"),
    uniqueArgs: commonUniqueArgsDescription("SSR"),
};

export const SIG_DocumentSignedDescription = {
    clientId: "ID given to a tax document during the upload time in Signature.",
    clientName: "Name given to a tax document during the upload time in Signature.",
    sentBy: "Email id of the sender.",
    totalRecipients: "Total number of recipients.",
    recipientList: "Email ids of all the recipients.",
    delegateeList: "Email ids of all the delegates.",
    signatureStatus: "Status of the Signature.",
    uniqueArgs: commonUniqueArgsDescription("Signature"),
    signedFilesDocumentType: "Type of the document selected during upload",
    signedFilesDocumentGuid: "Unique guid of the signature document",
    signedFilesDocumentId: "Unique integer id of the signature document",
    signedFilesExpiresOn: "Set expiry time during signature upload time",
    signatureId : "Unique guid of the signature.",
    statusDate : "Date at which status has been updated."
};

export const SUITE_ClientManagement_DocumentSignedDescription = {
    clientId: "Name given to a tax document during the upload time",
    clientType: "clientType (string) – Tax payer,spouse, partner etc name (string) – Name of the client email (string) – Email address of the client ssn (string) -Social Security number of the client",
    name: 'Name of taxpayer / Spouse',
    email: 'Email of taxpayer / Spouse',
    ssn: 'SSN of taxpayer / Spouse',
    countryCode: 'Country code of taxpayer / Spouse',
    mobile: 'Mobile number of taxpayer / Spouse',
};

export const engagementLetterSignedAndOrganizerCompletedDescription = {
    clientId: commonClientIdDescription("ORG"),
    uniqueArgs: commonUniqueArgsDescription("ORG"),
};

export const sourceDocumentUploadedDescription = {
    clientId: commonClientIdDescription("ORG"),
    uniqueArgs: commonUniqueArgsDescription("ORG"),
};

export const questionnaireCompletedDescription = {
    clientId: commonClientIdDescription("ORG"),
    uniqueArgs: commonUniqueArgsDescription("ORG"),
};

export const SSE_downloadDrlDocumentDescription = {
    documentRequestListId: "Unique identifier for document requested list.",
    clientEmailId: "Client's email address.",
    documentFieldName: "Document name while requesting documents list.",
    uploadedDate: "Date of document uploaded.",
    uniqueArgs: commonUniqueArgsDescription("SSE"),
};

export const GTR_DownloadEsignDocumentsDescription = {
    gatherId: "Unique Id for gather.",
    spouseName: "Name of Spouse.",
    clientId: commonClientIdDescription("GTR"),
    spouseEmail: "Spouse’s email id.",
    uniqueArgs: commonUniqueArgsDescription("GTR"),
};

export const GTR_downloadSourceDocumentsDescription = {
    clientName: 'Name of Taxpayer.',
    clientId: commonClientIdDescription("GTR"),
    engagementType: 'Engagement Type selected during upload time in Gather.',
    batchName: 'Batch name, if the Gather is part of any batch.'
};

const commonWebhookInfo = (productName: string, status: string) => `Once the user completes the signing process, ${productName} API module will deliver the event information to an API endpoint including signed/${status} documents SAS link. API endpoint configuration can be found in ${productName} Settings under Developer Section page.`
export const WEBHOOK_INFO = {
    SSE: "Once the client uploads the document from document request list, SSE API module will deliver the event information to an API endpoint including uploaded document SAS link. API endpoint configuration can be found in SSE Settings under Developer Section page.",
    SSR: commonWebhookInfo('SSR', 'uploaded'),
    SIG: commonWebhookInfo('SIG', 'partially'),
    SSO: commonWebhookInfo('ORG', 'uploaded'),
    GTR: commonWebhookInfo('GTR', 'uploaded'),
    ClMgnt: "Once the user Add/Update/Delete any of the Client, CLIENT MANAGEMENT API module will deliver the event information to an API endpoint. API endpoint configuration can be found in Client Management Settings under  Developer Section page",
    SIGSTATUSCHANGE : "Once the user changes the status of any signature, the SIG API Module will deliver the event information to an API endpoint, including status and other information. API endpoint configuration can be found in SIG Settings under the Developer Section page."
}

export const WEBHOOK_SPECIFICATION = {
    SSE: {
        downloadDRLDocument: [
            "This webhook will trigger whenever a document is uploaded against a delivered DRL request.",
            "Each document uploaded will be its own event trigger."
        ],
    },
    SSR: {
        downloadESignedDocument: [
            "This webhook will trigger when a delivered tax return is esigned or manually signed by the recipient.",
            "Download Esign Document webhook does not have an event type.",
            "This webhook will contain both esign and additional esign documents."
        ],
        returnStatusChange: [
            "This webhook will trigger whenever a tax return status is updated regardless of where in the product it was updated.",
            "The Return Status changed webhook does not have an event type."
        ],
    },
    SIG: {
        documentSigned: [
            "This webhook will trigger when any recipient signs a delivered signature request.",
            "If a signature request has multiple recipients, this webhook will trigger with sign and the status will be “partially signed”. When all signers of the signature request have signed then the status will be “ESigned.”"
        ],
        statusChange:[
            "This webhook will trigger whenever a signature status is updated regardless of where in the product it was updated.",
            "The following statuses will cause the web hook to activate: Processing, Out for Signature, Delivery Failed, E-Signed, Partially Signed, Signature Stamping Failed, Declined, Canceled.",
            "Webhook will provide signature status data that was changed via the ‘status’ property."
        ]
    },
    SSO: {
        engagementLetterSigned: [
            "This webhook will trigger when all delivered esign documents have been signed.",
            "Multiple signature files may have to be downloaded as a zip file."
        ],
        organizerCompleted: [
            "This webhook will trigger when the Organizer is marked as complete.",
            "If custom questions has been sent along with the organizer it will come with the organizer when the webhook is triggered."
        ],
        sourceDocumentUploaded: [
            "This webhook will trigger whenever a source document is uploaded to a delivered organizer.",
            "Multiple source document uploads will trigger the webhook multiple times."
        ],
        accessedOrganizerNotification: [
            "This webhook will trigger when an organizer recipient accesses the taxpayer experience for that organizer."
        ]
    },
    GTR: {
        downloadESignDocuments: [
            "This webhook will trigger when all esign documents have been signed or declined to sign by the Gather request recipient."
        ],
        downloadFillableOrganizer: [
            "This webhook will trigger when the organizer is marked as complete.",
            "If no organizer is delivered with the Gather request this webhook will no trigger."
        ],
        downloadSoruceDocuments: [
            "This webhook will trigger whenever a source document is uploaded to the Gather request.",
            "Multiple source document uploads will trigger the webhook multiple times."
        ]
    },
    SUITE: {
        clientManagement_clientInformationChange: [
            "This webhook will trigger when a change is made to the client management database.",
            "These changes include adding a new client, editing the information of the client, or removing a client from client management.",
            "Change in Client Information webhook will provide the method in which the client data was changed via ‘action type’ property.",
            "This webhook will provide ‘uid’ which is unique to each client in client management database."
        ]
    }
}
